import React from 'react';
import axios from 'axios';
import { render, screen, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import History from './history';

jest.mock('axios');

describe('History', () => {
  test('renders History component', async () => {
    const promise = Promise.resolve({
      data: {history_total_count: 1,
             notifications: [{
             id: 1,
             converted_notified_at: "2020/01/01 00:09:00",
             title: "ビデオ通話の予定があります",
             notice_kbn: "payment_complete"}]} });

    (axios.get as any).mockResolvedValue(promise);
    render(<History />);

    await act(() => promise);

    // screen.debug();

    expect(screen.getByText('検索したい内容を入力してください(氏名・カナ氏名・携帯電話番号・患者番号・生年月日)')).toBeInTheDocument();
  });
});
